import { Pressable } from 'components/Pressable';
import { theme } from 'lib/theme';
import { withHapticFeedback } from 'lib/withHapticFeedback';
import * as React from 'react';
import { StyleProp, StyleSheet, View, ViewStyle } from 'react-native';

type ListItemProps = {
  selected?: boolean;
  selectable?: boolean;
  onPress?: () => void;
  onLongPress?: () => void;
  style?: StyleProp<ViewStyle>;
  children: React.ReactNode;
};

export const ListItemGeneric: React.FC<ListItemProps> = ({
  children,
  onLongPress,
  onPress,
  selectable = true,
  selected,
  style,
}) => (
  <Pressable
    onPress={onPress || undefined}
    onLongPress={onLongPress ? withHapticFeedback(onLongPress) : undefined}
    disabled={!selectable}
    style={[styles.row, selectable ? styles.rowSelectable : undefined, style]}
    hoveredStyle={selectable ? styles.rowHovered : undefined}
    pressedStyle={selectable ? styles.rowPressed : undefined}
  >
    {selected && <View style={styles.selectionIndicator} />}
    {children}
  </Pressable>
);

const styles = StyleSheet.create({
  row: {
    alignItems: 'center',
    backgroundColor: theme.colors.white,
    borderBottomColor: theme.colors.navbar,
    borderBottomWidth: 1,
    flexDirection: 'row',
    opacity: 0.42,
  },
  rowHovered: {
    backgroundColor: '#fafafa',
  },
  rowPressed: {
    backgroundColor: '#DDDDDD',
  },
  rowSelectable: {
    opacity: 1,
  },
  selectionIndicator: {
    backgroundColor: `${theme.colors.blue}1A`,
    bottom: 1,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 1,
  },
});
